// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "footer li a {\n  color: #fff;\n  text-decoration: none;\n}\n\nfooter li a:hover {\n  text-decoration: underline;\n}\n\nfooter li a:focus {\n  border: 1px dotted #fff;\n  padding: 3px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
